import { useTranslation } from 'react-i18next'

import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const CustomerNotesCardEmpty = () => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Text type="titleM">{t('No hay notas para analizar')}</Text>
      <Text type="bodyMRegular">
        {t('Cuando los clientes dejen notas en sus solicitudes de devolución para este motivo, aparecerán aquí.')}
      </Text>
    </Styles.Container>
  )
}

export default CustomerNotesCardEmpty
